// extracted by mini-css-extract-plugin
export default {"createLoadFrame":"MovingLoad_createLoadFrame__9PQeB","createLoadFrameContent":"MovingLoad_createLoadFrameContent__xonqC","loadFrameButtons":"MovingLoad_loadFrameButtons__OCSgP"};